const AlcoholForm = ({}) => {
	return <div>AlcoolForm</div>;
};
export default AlcoholForm;
